<template>
  <div class="w-full h-full relative overflow-hidden">
    <!-- Professional Photo Background -->
    <div class="absolute inset-0">
      <img
        :src="robPortrait"
        alt="Rob Rickard - Professional Portrait"
        class="w-full h-full object-cover object-center opacity-35"
      />
      <!-- Dark overlay for text readability -->
      <div
        class="absolute inset-0 bg-gradient-to-t from-background/80 via-background/40 to-background/20"
      />
    </div>

    <!-- Hero Content -->
    <div class="absolute inset-0 flex items-end justify-start p-8 md:p-16">
      <div class="max-w-2xl">
        <h1 class="text-4xl md:text-6xl font-bold mb-4 text-white">
          Rob Rickard
        </h1>
        <p class="text-lg md:text-xl mb-2 text-white/90  leading-relaxed">
          Techpreneur, innovator, speaker, & 'top product guy' - Founder/CEO
        </p>
        <p class="text-lg md:text-xl mb-6 text-white/90  leading-relaxed">Guhemba Ltd., 912Rwanda, & Founder RWBuild (Rwanda Build Program)</p>

        <div class="flex items-center space-x-4">
          <div class="w-12 h-0.5 bg-accent"></div>
          <span class="text-accent font-medium">Scroll to explore</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import robPortrait from "@/assets/robPortrait.png";
import AOS from "aos";
import "aos/dist/aos.css";
export default {
  data() {
    return {
      robPortrait,
    };
  },
   mounted() {
    AOS.init({
      once: true, // animation triggers once when scrolled into view
      duration: 1200, // default animation duration
    });
  },
};
</script>

